import {SharedStrings} from '@colonist/types'

export enum SceneSubPathType {
    Profile,
    Replay,
    GiftUser,
}

interface SubPathPattern {
    name: SceneSubPathType
    pattern: RegExp
    extractData: (href: string) => string[] | undefined
}

const PROXY_PREFIX = '/.proxy'

const validLinks = [
    SharedStrings.DISCORD_CHANNEL,
    SharedStrings.BLOG_URL,
    SharedStrings.FEATURE_UPVOTE_URL,
    // General
    'https://i.imgur.com',
    'https://imgur.com',
    'https://youtube.com',
    'https://youtu.be/',
    'https://www.youtube.com/',
    // About Page
    'https://zw.linkedin.com/company/colonist',
    'https://stackoverflow.com/users/2589276/esqarrouth',
    'https://mmpractices.com',
    'https://twitter.com/cemdemir',
    'https://onrush.studio',
    'https://thellimist.com',
    'https://www.usehaystack.io',
    // Careers Page
    'https://en.wikipedia.org/wiki',
    'https://www.timedoctor.com/blog/what-does-fully-remote-work-mean',
    'https://lattice.com/library/what-is-asynchronous-work-heres-everything-you-need-to-know-to-implement-it-at-your-organization',
    'https://jobs.ashbyhq.com/colonist',
    // Community Page
    'https://twitch.tv/flyingchinaman',
    'https://twitch.tv/trissie89',
    'https://docs.google.com/forms/d/e/1FAIpQLScKDAhARzCrZyYrPzXvI7WnWCuffGU5q3O9rF559BIcN-71Bg',
    'https://forms.gle/RktNh31gRbfS7xon9',
    'https://forms.gle/4Jdie7yWxgn4Ufij8',
    // Tournament Links FROM 'Community Tournaments' Google Sheet. Ask Rob or Juan if these links break
    'https://bit.ly/CatanChampsSignUp',
    'https://discord.gg/4udZBpMUmn',
    // FAQ Page
    'https://medium.com/@charsept04/are-online-random-dice-broken-d069bdf92bd6',
    'https://macresearch.org/dst-root-ca-x3-expired-mac',
    'mailto:help@colonist.io',
    'https://airtable.com/shrqSxfnbzLVFnSue',
    'https://airtable.com/shrba2BxqilSVQkxi',
    // Privacy Policy Page
    'https://www.privacypolicygenerator.info',
    'https://www.generateprivacypolicy.com',
    'https://www.cookieconsent.com/what-are-cookies',
    'https://policies.google.com/technologies/ads',
    // Private Ads
    'https://play.google.com/store/apps',
    'https://apps.apple.com/us/app/colonist-io',
    // REPLAY
    'http://localhost:8080/replay',
    'https://test1.katan.io/replay',
    'https://test2.katan.io/replay',
    'https://test3.katan.io/replay',
    'https://test4.katan.io/replay',
    'https://test5.katan.io/replay',
    'https://test6.katan.io/replay',
    'https://test7.katan.io/replay',
    'https://test8.katan.io/replay',
    'https://test9.katan.io/replay',
    'https://test10.katan.io/replay',
    'https://onlinecatan.com/replay',
    'https://hexs.io/replay',
    'https://colonist.io/replay',
    // Social Media
    'https://www.facebook.com/colonistio/',
    'https://twitter.com/colonistio',
    'https://www.instagram.com/colonist_io/',
    'https://www.reddit.com/r/Colonist/',
    // Values Page
    'https://dilbertblog.typepad.com/the_dilbert_blog/2007/06/the_day_you_bec.html',
    // Press Kit Page
    'https://iogames.space/',
    'https://www.crazygames.com/c/io',
    'https://titotu.io/',
    'https://www.kongregate.com/games/demiculus/katan',
    'https://www.game-game.com.ua/196064/',
    'https://www.minijuegos.com/juego/katan-io',
    'https://www.miniplay.com/game/katan-io',
    'https://igroutka.ru/igry-io/29435-kolonist-io.html',
    'https://www.silvergames.com/en/catan-online',
    'https://multoigri.ru/game/igra-colonist-io',
    'https://www.dicebreaker.com/games/catan-1/news/catan-clone-free-to-play-inside-discord',
    'https://www.womansday.com/life/g32378940/best-online-games-online-group-games/',
    'https://www.inverse.com/gaming/colonist-settlers-of-catan-online-free-game',
    'https://dailyillini.com/special-sections/international-student-guide/2020/07/31/video-games-pass-time-quarantine/',
    'https://www.asiaone.com/digital/top-free-online-board-games-play-quarantine-friends',
    'https://lifehacker.com/our-13-favorite-free-games-to-play-over-video-chat-1844648370/slides/11',
    'https://www.yahoo.com/lifestyle/9-best-online-group-games-204500619.html',
    'https://www.womansday.com/life/g32378940/best-online-games-online-group-games',
    'https://studybreaks.com/tvfilm/online-board-games/',
    'https://victoryconditions.com/settlers-of-catan-online-for-free-https-colonist-io/',
    'https://tinyurl.com/Colonist-Assets',
    'https://www.figma.com/file/Gf8mPaTkXPdLDqxaN5qKYD/Colonist.io-Board-Builder',
    'https://www.figma.com/file/UsKBXmKMdXJVog8Y9f7ZgS/',
    'https://www.figma.com/design/fGIuzwe4vB2vPCVf9hR28m/Youtube-Thumbnail-Builder',
    'https://www.loom.com/share/c74dcf114f394b70b6ee7e16c8dbf393',
    'https://web.archive.org/web/20210401234123/https://www.copyright.gov/fls/fl108.pdf',
    'https://www.dawnofcrafting.com/',
    // Profile Page
    'https://colonist.io/profile',
    // Gifting
    'https://colonist.io/store',
    // Patch Notes
    'https://docs.google.com/forms/d',
]

const validPaths = [
    '/',
    '/disable-ad-block',
    '/dist',
]

const validSceneSubPaths: SubPathPattern[] = [
    {
        name: SceneSubPathType.Profile,
        pattern: /^\/profile\/[^/]+(?:[#?].*)?$/,
        extractData: (href: string) => {
            const match = href.match(/^\/profile\/([^#?]+)/)
            if(!match) return undefined

            const decodedUsername = decodeURIComponent(match[1])
            return [decodedUsername]
        },
    },
    {
        name: SceneSubPathType.Replay,
        pattern: /^\/replay\?gameId=\d+&playerColor=\d+$/,
        extractData: (href: string) => {
            const url = new URL(href, 'https://colonist.io')
            const gameId = url.searchParams.get('gameId')
            const playerColor = url.searchParams.get('playerColor')
            return (gameId && playerColor) ? [gameId, playerColor] : undefined
        },
    },
    {
        name: SceneSubPathType.GiftUser,
        pattern: /^\/store(?:\?username=([\w-]+))?#gift$/,
        extractData: (href: string) => {
            const match = href.match(/^\/store(?:\?username=([\w-]+))?#gift$/)
            return match ? [match[1] ?? undefined] : undefined
        },
    },

]

const validLinkPatterns = validLinks.map((link) => new RegExp('^' + link.replace(/\//g, '\\/') + '.*$'))

const validPathPatterns = validPaths.map((link) => {
    if(link === '/') return new RegExp(`^(${PROXY_PREFIX})?\\/$`)
    return new RegExp(`^(${PROXY_PREFIX})?` + link.replace(/\//g, '\\/') + '.*$')
})

export function isValidLink(href: string): boolean {
    return validLinkPatterns.some((pattern) => pattern.test(href))
}

export function isValidPath(href: string): boolean {
    return validPathPatterns.some((pattern) => pattern.test(href))
}

export function getValidSubPath(href: string): SubPathPattern | undefined {
    const matchedPath = validSceneSubPaths.find(({pattern}) => pattern.test(href))
    return matchedPath
}

export function stripProxyPrefix(href: string): string {
    return href.startsWith(PROXY_PREFIX) ? href.slice(PROXY_PREFIX.length) : href
}
